export default __webpack_public_path__ + "static/media/riachuelo.960f022c.png";